<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-pencil-alt</v-icon>Edit Company
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-card flat>
            <v-form>
              <v-text-field
                :error-messages="messages.first_name"
                v-model="user.first_name"
                label="First Name"
                type="text"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.last_name"
                v-model="user.last_name"
                label="Last Name"
                type="text"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.company_name"
                v-model="user.company_name"
                label="Company Name"
                type="text"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.email"
                v-model="user.email"
                label="Email"
                type="text"
              ></v-text-field>
                 <v-select
                      v-model="user.manager_id"
                      :items="accountManagerList"
                      item-text="full_name"
                      item-value="id"
                      label="Assign Manager"
                      class="mt-4"
                      :menu-props="{ maxHeight: '400' }"
                      attach
              ></v-select>
              <!-- <drop-zone
                      :type="type"
                      :accepted="accepted"
                      :image.sync="company_logo"
                      class="mt-5"
                      text="Click here to upload Customer Logo (155 x 33)"
              ></drop-zone>
              <p class="block text-left mt-4 caption">
                Max upload filesize: 1MB <br />
                Dimension should be 155 x 33<br/>
                Accepted file formats: png, jpg
              </p> -->
              <CompanyLogoUpload 
                :image.sync="company_logo"
                class="mt-5 mb-5"
                text="Click here to upload Customer Logo"
                :type="'company-logo'"
                :accepted="'image/jpg,image/jpeg,image/png'"
                :dropzone-id="'company_logo'"
              />
              <p class="block text-left mt-4 caption">
                Max upload filesize: 1MB<br />
                Recommended Dimensions: 475 × 115<br />
                Accepted formats: PNG, JPG
              </p>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!s3Uploading" color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="s3Uploading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="updateUser">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import userAPI from "@/api/user.js";
// import DropZone from "@/components/global/Dropzone";
import CompanyLogoUpload from "@/components/global/CompanyLogoUpload";

export default {
  name: "Edituser",
  components: {
    // DropZone,
    CompanyLogoUpload
  },
  props: {
    id: {
      type: String,
      default: null
    },
    params: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      type: "company-logo",
      accepted: "image/jpg,image/jpeg,image/png",
      accountManagerList: [],
      messages: {},
      user: {},
      groups: [],
      valid: true,
      successMessage: "Customer Successfully Updated.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      noOfEmployeesOptions: [
        {
          id: 1,
          name: "1 to 20"
        },
        {
          id: 2,
          name: "21 to 50"
        },
        {
          id: 3,
          name: "51 to 100"
        },
        {
          id: 4,
          name: "101 to 250"
        },
        {
          id: 7,
          name: "251 to 500"
        }
      ],
      noOfEmployeesOptions2: [
        {
          id: 1,
          name: "1 to 20"
        },
        {
          id: 5,
          name: "21 to 30"
        },
        {
          id: 6,
          name: "31 to 50"
        },
        {
          id: 3,
          name: "51 to 100"
        },
        {
          id: 4,
          name: "101 to 250"
        },
        {
          id: 7,
          name: "251 to 500"
        }
      ],
      waitMessage: "Please wait, we are uploading your image.",
      loading: false
    };
  },
  computed: {
    company_logo() {
      return this.user.hasOwnProperty("company_avatar") && this.user.company_avatar!=''
              ? this.user.company_avatar.url
              : null;
    },
    s3Uploading() {
      //if(this.user.company_logo.url !=undefined) {
        return this.$store.getters.s3Uploading;
      //}
    },
    showEmpOption2() {
        if((this.id=="qnwmkv57d05blag6" || this.user.partner_id=="qnwmkv57d05blag6") || (this.id=="xeml73oyko4d9qbr" || this.user.partner_id=="xeml73oyko4d9qbr")) {
            return true;
        } else {
            return false;
        }
    }
  },
  mounted() {
    this.$store.dispatch("setS3Uploading", false);
    this.getUser(this.id);
   // this.getAccountManagerList();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    changeConfirmation() {
      this.$snotify.confirm(this.changeRole, {
        backdrop:0.3,                         
        buttons: [
          {
            text: "OK",
            className: 'toast-continue-button',
            action: toast => this.contine(toast)
          }       
        ]
      });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
    },
    getUser(id) {
      userAPI.getUser(id, "?include=groups").then(response => {
        this.user = response.data.data;
        this.$store.dispatch('setDropzoneLoaded', { id: 'company_logo', value: true });
      });
    },
    updateUser() {
      this.loading = true;
      if (this.$store.getters.s3Url != '') {
        this.$snotify.info(this.waitMessage);
      }
      userAPI
          //.updateUser(this.id, this.user)
        .updateOwner(this.id, this.user, this.$store.getters.s3Url, this.$store.getters.fileDetails)
        .then(() => {
          this.$store.dispatch("profile");
          this.closePanel();
          EventBus.$emit("USERS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getAccountManagerList() {
      userAPI.getManagers(this.$store.getters.user.id).then(response => {
        this.accountManagerList = response.data.data;
      });
    }
  }
};
</script>
